export enum FormFieldLabel {
  ASSIGNMENT_OBJECTIVES = 'Assignment Objectives'
}

export const TOOLTIP_ACCESSIBLE_NAME = 'Information about Objectives';
